import useSWR from 'swr';

import { readAgentConversationDocumentProcessingStage } from './agentConversationsApi';
import { commendaAiDocumentProcessingKey } from './api';
import { CommendaAiDocumentProcessingStage } from './types';

const POLL_INTERVAL_MS_BY_STAGE: Record<
  CommendaAiDocumentProcessingStage,
  number
> = {
  [CommendaAiDocumentProcessingStage.PROCESSING]: 5000,
  [CommendaAiDocumentProcessingStage.AWAITING_UPLOAD]: 15000,
  [CommendaAiDocumentProcessingStage.IDLE]: 0,
};

/** Polls a conversation's document processing stage: often while files process, rarely while
 * uploads are pending, and not at all once idle. */
export function useCommendaAiDocumentProcessingStage(conversationId: string) {
  const { data, isLoading, error, mutate } = useSWR(
    commendaAiDocumentProcessingKey(conversationId),
    ([, id]) => readAgentConversationDocumentProcessingStage(id),
    {
      refreshInterval: (latest) =>
        latest ? POLL_INTERVAL_MS_BY_STAGE[latest.stage] : 0,
    }
  );

  return { stage: data?.stage, isLoading, error, mutate };
}
